
import CustomChipLink from "@/components/CustomChipLink.vue";
import EditUser from "@/components/users/EditUser.vue";
import KeyStatus from "@/components/keys/KeyStatus.vue";
import {Component, Vue} from "vue-property-decorator";
import {Getter} from "vuex-class";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiNfcVariant } from "@mdi/js";
import UserBadgeNfc from "@/components/users/UserBadgeNfc.vue";
import DisableNotificationBySmsAndMail from "@/components/DisableNotificationBySmsAndEmail.vue";

Component.registerHooks([
    "beforeRouteUpdate",
]);

@Component({
    components: {
        UserBadgeNfc,
        CustomChipLink,
        EditUser,
        KeyStatus,
        DisableNotificationBySmsAndMail,
        SvgIcon,
    },
})
export default class User extends Vue {
    @Getter private currentUser: any;
    @Getter private isAdmin: boolean;
    @Getter private canDoInEnvCompany: (right: string) => boolean;
    @Getter private envCompanyId: number|null;

    private userId: number = null;
    private user: any = null;
    private loadingGetUser: boolean = false;
    private mdiNfcVariant = mdiNfcVariant;
    private displayUserBadgeNFC: boolean = false;

    private subTab: string = null;
    private loadingSubTab: boolean = false;

    get isMyPage(): boolean {
        return this.currentUser?.id === this.user?.id;
    }

    get canEditProfile(): boolean {
        // Only if this is the current user's page, or the current user is Admin
        return this.isMyPage || this.isAdmin;
    }

    get canCreateBadge(): boolean {
      return this.canDoInEnvCompany("BADGE_NFC_MANAGEMENT");
    }

    get routerParams(): any {
        return this.$route.params;
    }

    private beforeRouteUpdate(to, from, next): void {
      if (Number(to.params?.id) !== this.userId) {
        // Refetch data for new user since component is not re-rendered
        this.userId = Number(to.params?.id);
        this.getUserById().then(() => next());
      } else {
        next();
      }
    }

    private mounted(): void {
        this.userId = Number(this.$route.params.id);
        this.getUserById();
    }

    private getUserById(): Promise<void> {
        this.loadingGetUser = true;
        return this.$store.dispatch("users/getUserById", {
            id: this.userId,
        }).then((user) => {
            this.user = user;
        }).catch((err) => {
            this.$store.commit("alerts/displayError", {
                msg: err,
            });
        }).finally(() => {
            this.loadingGetUser = false;
        });
    }

    private showUserBadgeNfc(): void {
      this.displayUserBadgeNFC = true;
    }

    private closeUserBadgeNfc(): void {
      this.displayUserBadgeNFC = false;
    }
}
